import { useEffect, useState } from "react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_women-economy/artifacts/p7si2gi8_shescan%20logo%20mark%20and%20nameOrangeFinal.png";

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/85 backdrop-blur-xl border-b border-line"
          : "bg-transparent"
      }`}
    >
      <div className="w-full max-w-none px-4 sm:px-8 lg:px-12">
        <div className="flex items-center justify-between h-20 sm:h-24">
          <button
            onClick={() => scrollTo("hero")}
            className="flex items-center gap-3 group"
            data-testid="nav-logo"
          >
            <img
              src={LOGO_URL}
              alt="SheScan"
              className="h-14 sm:h-16 lg:h-20 w-auto object-contain"
            />
            <span className="hidden sm:flex flex-col leading-none">
              <span className="font-sans text-[10px] sm:text-[11px] text-ink-soft tracking-widest font-semibold uppercase">
                The Redirect
              </span>
              <span className="font-sans text-[10px] text-ink-soft tracking-wider font-medium mt-1">
                Verified women-owned registry
              </span>
            </span>
          </button>

          <nav className="hidden md:flex items-center gap-8 lg:gap-10">
            {[
              { id: "problem", label: "Problem" },
              { id: "product", label: "Product" },
              { id: "showcase", label: "Showcase & Services" },
              { id: "extension", label: "Extension" },
              { id: "vision", label: "Vision" },
              { id: "investors", label: "Investors", route: true },
            ].map((l) => (
              <button
                key={l.id}
                onClick={() => {
                  if (l.route) {
                    window.location.href = `/${l.id}`;
                  } else {
                    scrollTo(l.id);
                  }
                }}
                data-testid={`nav-link-${l.id}`}
                className="font-sans font-semibold text-sm uppercase tracking-widest text-ink hover:text-link transition-colors duration-150 link-under"
              >
                {l.label}
              </button>
            ))}
          </nav>

          <button
            onClick={() => scrollTo("signup")}
            data-testid="nav-cta"
            className="border-2 border-brand-orange bg-brand-orange text-white font-sans font-semibold uppercase text-sm tracking-widest px-5 py-3 sm:px-6 sm:py-3.5 hover:bg-ink hover:border-ink transition-colors duration-150"
          >
            Get started
          </button>
        </div>
      </div>
    </header>
  );
}
